import { GenericDataOutputResponse, NotifikasiReceipt, ProfileData } from "@/types/shared.types";
import useSWR from "swr";

export type ProfileResponse = {
  data: ProfileData
}

export function useNotifikasi(authenticatedFetcher: <T>(input: (RequestInfo | URL)) => Promise<T>) {
  const response = useSWR(`${process.env.NEXT_PUBLIC_API_URL}/v2/notifikasi/me?filters=[{"id":"isRead","value":"false"}]&sorting=[{"id":"createdAt","desc":true}]`, authenticatedFetcher<GenericDataOutputResponse<NotifikasiReceipt>>);
  return response;
}

export function useProfile(authenticatedFetcher: <T>(input: (RequestInfo | URL)) => Promise<T>) {
  const response = useSWR(`${process.env.NEXT_PUBLIC_API_URL}/v2/auth/me`, authenticatedFetcher<ProfileResponse>);
  return {
    ...response,
    data: response.data?.data
  };
}